import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import { IPatientPlanEligibilityInfoResponse } from "../../../models/gms/IPatientPlanEligibilityInfoResponse";
import ToggleButtonList from "../../ToggleButtonList";
import IStaticData from "../../../models/staticData/IStaticData";


export interface PatientPlanEligibilityViewProps {
    patientPlanEligibilityInfo: IPatientPlanEligibilityInfoResponse,
    updatedPatientPlanEligibilityInfo: IPatientPlanEligibilityInfoResponse,
    staticPatientPlanEligibilityMaskAnswers: IStaticData[],
    updatePatientPlanEligibilityInfo: (patientPlanEligibilityInfo: IPatientPlanEligibilityInfoResponse) => void,
    userId: String,
    secondaryUserId: String,
    isSelf: Boolean,
    updatePatientPlanEligibilityMasks: (userId: String, secondaryUserId: String, isSelf: Boolean, eligibilityMasks: String[]) => Promise<any>
}

export interface PatientPlanEligibilityViewState {
    ignoreLifeStyleConditions: string[]
}

export default class PatientPlanEligibilityView extends React.Component<PatientPlanEligibilityViewProps, PatientPlanEligibilityViewState> {

    constructor(props: PatientPlanEligibilityViewProps) {
        super(props);
        this.state = {
            ignoreLifeStyleConditions: []
        };
    }

    updatePatientPlanEligibilityMaskInfo = (patientPlanEligibilityInfo: IPatientPlanEligibilityInfoResponse, keyword: string, value: string) => {
        switch(keyword) {
            case "ignoreLifeStyleConditions": {
                if (value === "no" || value === "") {
                    const index = patientPlanEligibilityInfo.patientPlanEligibilityMask ? patientPlanEligibilityInfo.patientPlanEligibilityMask.findIndex((mask) => mask === "LIFESTYLE") : -1
                    if (index > -1) {
                        patientPlanEligibilityInfo.patientPlanEligibilityMask = [
                            ...patientPlanEligibilityInfo.patientPlanEligibilityMask.slice(0, index),
                            ...patientPlanEligibilityInfo.patientPlanEligibilityMask.slice(index+1, patientPlanEligibilityInfo.patientPlanEligibilityMask.length)
                        ]
                    }
                } else {
                    patientPlanEligibilityInfo.patientPlanEligibilityMask = patientPlanEligibilityInfo.patientPlanEligibilityMask ? [...patientPlanEligibilityInfo.patientPlanEligibilityMask, "LIFESTYLE"] : ["LIFESTYLE"]
                }
            }
        }
        return patientPlanEligibilityInfo
    }
    onChange = (items: string[], keyword: string) => {
        let patientPlanEligibilityInfo = { ...this.props.updatedPatientPlanEligibilityInfo };
        let convertedItems = items.map(item => this.props.staticPatientPlanEligibilityMaskAnswers[0].values.find(eligibilityMask => eligibilityMask.internalValue === item));
        let value = convertedItems[0] ? convertedItems[0].internalValue : "";
        patientPlanEligibilityInfo = this.updatePatientPlanEligibilityMaskInfo(patientPlanEligibilityInfo, keyword, value)
        this.setState({ignoreLifeStyleConditions: value ? [value] : []})
        this.props.updatePatientPlanEligibilityInfo(patientPlanEligibilityInfo);
        this.props.updatePatientPlanEligibilityMasks(this.props.userId, this.props.secondaryUserId, this.props.isSelf, patientPlanEligibilityInfo.patientPlanEligibilityMask)
    }

    render() {
        return (<div>
            {
                _isEmpty(this.props.patientPlanEligibilityInfo) ?
                    <div>
                        <p>No data to show</p>
                    </div>
                    : <div>
                        <p>{`Status: ${this.props.patientPlanEligibilityInfo.eligibility}`}</p>
                        <p>{`Reason: ${
                            this.props.patientPlanEligibilityInfo.compatibilityStatus === "UNDERWEIGHT" ||
                                this.props.patientPlanEligibilityInfo.compatibilityStatus === "OVERWEIGHT" ||
                                this.props.patientPlanEligibilityInfo.compatibilityStatus === "NORMAL" ||
                                this.props.patientPlanEligibilityInfo.compatibilityStatus === "MODERATE" ||
                                this.props.patientPlanEligibilityInfo.compatibilityStatus === "OBESE" ?
                                `User BMI is ${this.props.patientPlanEligibilityInfo.compatibilityStatus}`
                                : this.props.patientPlanEligibilityInfo.compatibilityStatus === "LIFESTYLE_CONDITION" ?
                                    `User has a ineligible lifestyle condition`
                                    : this.props.patientPlanEligibilityInfo.compatibilityStatus === "INELIGIBLE_CALORIES" ?
                                        `User calorie requirement is not supported`
                                        : this.props.patientPlanEligibilityInfo.compatibilityStatus === "CONFLICTING_PLAN_EXISTS" ?
                                            `User is already on a plan`
                                            : this.props.patientPlanEligibilityInfo.compatibilityStatus === "NO_USER_PERSONA" ?
                                                `We do not have a plan for this user`
                                                : null}
                        `}
                        </p>
                        {
                            this.props.patientPlanEligibilityInfo.compatibilityStatus === "LIFESTYLE_CONDITION" ?
                            <div style={{display: "flex"}}>
                                <div>Override user lifestyle condition?</div>
                            <div className={"buttons-container"}>
                                <ToggleButtonList listItems={this.props.staticPatientPlanEligibilityMaskAnswers[0].values}
                                                    selectedItems={this.state.ignoreLifeStyleConditions}
                                                    onSelectionChange={(items: string[]) => this.onChange(items, "ignoreLifeStyleConditions")}/>
                            </div>
                            </div>
                            : <div></div>
                        }
                    </div>
            }
        </div>
        )
    }
}